import cn from 'classnames';
import React from 'react';

import { Icon, Space } from '@sravni/react-design-system';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { ArrowLeft } from '@sravni/react-icons';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { SelectCity } from '@components/AboutBlock/components/SelectCity';
import { ServiceFilter } from 'src/components/ServiceFilter';

import { FILTERS_NAME, RATING_TYPES } from '../../constants/filters';
import { DEFAULT_RATING_REGION } from '../../constants/locations';
import { useMetadataByPath } from '../../hooks/useMetadataByPath';
import { useFilters } from '../../store/hooks/filters';
import pageStyles from '../../styles/page.module.scss';
import { makeFiltersLink } from '../../utils/routing';

import styles from './about-block.module.scss';

export const AboutBlock = React.memo(() => {
  const metadata = useMetadataByPath();
  const isMobile = useIsMobile();
  const cx = useStyles(styles);
  const filters = useFilters();
  const { organizationType, location, ratingType, service } = filters;
  const organizationHelpers = getOrganizationHelpers(organizationType);

  let headingTitle = metadata?.heading;
  if (!headingTitle) {
    headingTitle = `Рейтинг ${organizationHelpers.namesType.mode9} ${location?.nameLocative ?? ''}`;
    if (ratingType === RATING_TYPES.Products) {
      headingTitle = `Рейтинг продуктов по услуге ${service.label.toLowerCase()} ${location?.nameLocative ?? ''}`;
    } else if (service) {
      headingTitle = `Рейтинг ${service.label.toLowerCase()} ${location?.nameLocative ?? ''}`;
    }
  }

  let backLinkLabel = '';
  let filtersForBackLink = null;

  if (service) {
    backLinkLabel = `Рейтинг ${organizationHelpers.namesType.mode9}`;
    filtersForBackLink = {
      ...filters,
      [FILTERS_NAME.Service]: null,
      [FILTERS_NAME.RatingType]: RATING_TYPES.Organizations,
    };
  } else if (location) {
    backLinkLabel = `Рейтинг ${organizationHelpers.namesType.mode9} ${DEFAULT_RATING_REGION.nameGenitive}`;
    filtersForBackLink = {
      ...filters,
      [FILTERS_NAME.Location]: null,
    };
  }

  const backLink = Boolean(filtersForBackLink) && makeFiltersLink(filtersForBackLink);

  return (
    <div className={pageStyles.content}>
      <Space size={isMobile ? 16 : 12} direction="vertical" className={cx('grid')} justify="center">
        {Boolean(filtersForBackLink) && (
          <Link href={backLink} strong>
            <Space direction="horizontal" size={2}>
              <Icon icon={<ArrowLeft />} size={20} />
              <Text size={14}>{backLinkLabel}</Text>
            </Space>
          </Link>
        )}

        <Heading level={2} as="h1">
          {headingTitle}
        </Heading>

        <SelectCity />

        <Text size={14} className={cx('h-color-D60', 'lead')}>
          Рейтинг Сравни рассчитывается на{'\u00A0'}основе количества и{'\u00A0'}качества отзывов, а{'\u00A0'}также
          числа успешно решенных проблем пользователей.{' '}
          <Link href="/novost/2022/8/08/kak-schitaetsya-rejting-sravni/" target="_blank">
            Подробнее
          </Link>
        </Text>

        <ServiceFilter className={cn({ 'h-mt-20': !isMobile })} />
      </Space>
      {!isMobile && (
        <div>
          <img src={require('../../../public/images/cat.png')} alt="Котик на пьедестале" className={cx('image')} />
        </div>
      )}
    </div>
  );
});
